module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('button', {
    staticClass: "left",
    class: _vm.arrowClasses,
    on: {
      "click": function($event) {
        _vm.arrowEvent(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "chevron-left"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-list']
  }, [_c('div', {
    class: [_vm.prefixCls + '-track'],
    style: (_vm.trackStyles)
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('button', {
    staticClass: "right",
    class: _vm.arrowClasses,
    on: {
      "click": function($event) {
        _vm.arrowEvent(1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "chevron-right"
    }
  })], 1), _vm._v(" "), _c('ul', {
    class: _vm.dotsClasses
  }, [_vm._l((_vm.slides.length), function(n) {
    return [_c('li', {
      class: [n - 1 === _vm.currentIndex ? _vm.prefixCls + '-active' : ''],
      on: {
        "click": function($event) {
          _vm.dotsEvent('click', n - 1)
        },
        "mouseover": function($event) {
          _vm.dotsEvent('hover', n - 1)
        }
      }
    }, [_c('button')])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18e6a7aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/carousel/carousel.vue
// module id = 599
// module chunks = 1